class ProductCardCarouselMobile extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.slider = this.els?.slider?.element
    this.slides = this.els?.slide?.elements || []
    this.prevBtn = this.els?.prev?.element
    this.nextBtn = this.els?.next?.element

    this.currentIndex = 0

    this.updateButtonStates()
    this.setupListeners()
  }

  setupListeners () {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () =>
        this.scrollToSlide(this.currentIndex - 1),
      )
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () =>
        this.scrollToSlide(this.currentIndex + 1),
      )
    }

    if (this.slider) {
      this._debouncedHandleScroll = window.BAO.Utils.debounce(
        this.handleScroll.bind(this),
        50,
      )
      this.slider.addEventListener('scroll', this._debouncedHandleScroll)
    }
  }

  scrollToSlide (index) {
    if (!this.slider || !this.slides.length) return

    const clampedIndex = Math.max(0, Math.min(index, this.slides.length - 1))
    const slide = this.slides[clampedIndex]

    if (slide) {
      slide.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      })
      this.currentIndex = clampedIndex
      this.updateButtonStates()
    }
  }

  handleScroll () {
    const sliderRect = this.slider.getBoundingClientRect()
    let minDiff = Infinity
    let closestIndex = 0

    this.slides.forEach((slide, idx) => {
      const diff = Math.abs(
        slide.getBoundingClientRect().left - sliderRect.left,
      )

      if (diff < minDiff) {
        minDiff = diff
        closestIndex = idx
      }
    })

    if (closestIndex !== this.currentIndex) {
      this.currentIndex = closestIndex
      this.updateButtonStates()
    }
  }

  updateButtonStates () {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0
    }

    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex === this.slides.length - 1
    }
  }
}

if (!customElements.get('product-card-carousel-mobile')) {
  customElements.define(
    'product-card-carousel-mobile',
    ProductCardCarouselMobile,
  )
}
